var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 17,
    viewBox: "0 0 227 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_1508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227 7H200V17H227V7Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 5H202V16H219V5Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 3H204V14H227V3Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 1H206V12H227V1Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3H0V14H13V3Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5H2V16H15V5Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 7H4V17H17V7Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 9H0V17H227V9Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H0V3.02H14V2Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2H13V5H14V2Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H13V5H16V4Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H15V7H16V4Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 6H15V7H18V6Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7H17V9H18V7Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 8H17V9H200V8Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 6H199V9H200V6Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 6H200V7H202V6Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 4H201V7H202V4Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 4H201V5H204V4Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 2H203V3H206V2Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 2H203V4H204V2Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 0H205V2H206V0Z",
    fill: "#142E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 0H206V1H227V0Z",
    fill: "#142E4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_1508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBar);
export default __webpack_public_path__ + "static/media/bottom-bar.fbc88a7bfe266ea9cfd1e6058acb3825.svg";
export { ForwardRef as ReactComponent };